'use es6';

import { combineReducers } from 'redux';
import { CUSTOM_FONTS_FETCH_FONTS } from 'DesignData/actions/ActionTypes';
import * as RequestStatus from 'DesignData/enums/RequestStatus';

const customFonts = (state = {}, action) => {
  switch (action.type) {
    case CUSTOM_FONTS_FETCH_FONTS:
      {
        const {
          fonts,
          options
        } = action;
        if (!(fonts && fonts.length) || !(options && options.path)) return state;
        return Object.assign({}, state, {
          [options.path]: fonts
        });
      }

    default:
      return state;
  }
};

const customFontsRequestStatus = (state = {}, action) => {
  switch (action.type) {
    case CUSTOM_FONTS_FETCH_FONTS:
      {
        const {
          error,
          fonts,
          options
        } = action;
        if (!(options && options.path)) return state;
        if (fonts) return Object.assign({}, state, {
          [options.path]: RequestStatus.SUCCEEDED
        });
        if (error) return Object.assign({}, state, {
          [options.path]: RequestStatus.FAILED
        });
        return Object.assign({}, state, {
          [options.path]: RequestStatus.UNINITIALIZED
        });
      }

    default:
      return state;
  }
};

export default combineReducers({
  customFonts,
  customFontsRequestStatus
});